import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    data: '',
    product: '',
    order: {},
    request: {},
    mirror: {},
    mirrorItens: [],
    priceList: {},
    taxes: {},
    defects: {},
    parts: {},
    accounts: {},
    bonus: [],
    user: {},
    mirror_user: {},
    alert: {},
    remittance: {},
    service: '',
    assistant: {},
    checkList: {},
    iluminationOrder: {},
    iluminationProduct: {},
  },
  getters: {
    getData: (state) => {
      return state.data
    },
    getProduct: (state) => {
      return state.product
    },
    getOrder: (state) => {
      return state.order
    },
    getRequest: (state) => {
      return state.request
    },
    getMirror: (state) => {
      return state.mirror
    },
    getMirrorItens: (state) => {
      return state.mirrorItens
    },
    getPriceList: (state) => {
      return state.priceList
    },
    getTaxes: (state) => {
      return state.taxes
    },
    getDefects: (state) => {
      return state.defects
    },
    getParts: (state) => {
      return state.parts
    },
    getAccounts: (state) => {
      return state.accounts
    },
    getBonus: (state) => {
      return state.bonus
    },
    getUser: (state) => {
      return state.user
    },
    getMirrorUser: (state) => {
      return state.mirror_user
    },
    getAlert: (state) => {
      return state.alert
    },
    getService: (state) => {
      return state.service
    },
    getRemittance: (state) => {
      return state.remittance
    },
    getAssistant: (state) => {
      return state.assistant
    },
    getCheckList: (state) => {
      return state.checkList
    },
    getIluminationOrder: (state) => {
      return state.iluminationOrder
    },
    getIluminationProduct: (state) => {
      return state.iluminationProduct
    }
  },
  mutations: {
    setCheckList: (state, checkList) => {
      return state.checkList = checkList
    },
    setData (state, data) {
      state.data = data
    },
    setProduct (state, product) {
      state.product = product
    },
    setOrder (state, order) {
      state.order = order
    },
    setRequest (state, request) {
      state.request = request
    },
    setMirror (state, mirror) {
      state.mirror = mirror
    },
    setMirrorItens (state, mirrorItens) {
      state.mirrorItens = mirrorItens
    },
    setPriceList (state, priceList) {
      state.priceList = priceList
    },
    setTaxes (state, taxes) {
      state.taxes = taxes
    },
    setDefects (state, defects) {
      state.defects = defects
    },
    setParts (state, parts) {
      state.parts = parts
    },
    setAccounts (state, accounts) {
      state.accounts = accounts
    },
    setBonus (state, bonus) {
      state.bonus = bonus
    },
    setUser (state, user) {
      state.user = user
    },
    setMirrorUser (state, mirror_user) {
      state.mirror_user = mirror_user
    },
    setAlert (state, alert) {
      state.alert = alert
    },
    setService (state, service) {
      state.service = service
    },
    setRemittance (state, remittance) {
      state.remittance = remittance
    },
    setAssistant (state, assistant) {
      state.assistant = assistant
    },
    setIluminationOrder (state, iluminationOrder) {
      state.iluminationOrder = iluminationOrder
    },
    setIluminationProduct (state, iluminationProduct) {
      state.iluminationProduct = iluminationProduct
    }
  },
  actions: {
  },
  modules: {
  }
})
